export default __webpack_public_path__ + "static/media/OscilloscopeImg.8165c8e5.jpg";